module.exports = __webpack_public_path__ + "static/media/ic-menu.1ca414e2.svg";